import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useUser } from "../../contexts/UserContext";
import { useBankAccounts } from "../../domain/services/hooks/useBankAccounts";
import LoadingState from "../common/LoadingState";

const ProtectedRoute: React.FC = () => {
  const { currentUser, loading } = useUser();
  const { bankAccounts, loading: bankAccountsLoading } = useBankAccounts();
  const location = useLocation();

  if (loading || bankAccountsLoading) {
    return <LoadingState message="Loading..." />;
  }

  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user is authenticated but has no bank accounts and isn't already on the onboarding path
  const isOnboardingPath = location.pathname.startsWith("/onboarding");
  const hasNoBankAccounts = !bankAccounts || bankAccounts.length === 0;

  if (hasNoBankAccounts && !isOnboardingPath) {
    return <Navigate to="/onboarding/banks" replace />;
  }

  // If user has accounts but is trying to access onboarding, redirect to dashboard
  if (bankAccounts?.length > 0 && isOnboardingPath) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
